import React, { useState } from "react";

const OtpInput = ({ onOtpComplete }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically focus the next input
      if (index < 5) {
        e.target.nextSibling.focus();
      }

      // Trigger the callback when all fields are filled
      if (newOtp.every((digit) => digit !== "")) {
        onOtpComplete(newOtp.join(""));
      }
    } else if (value === "") {
      // Allow clearing the field
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      e.target.previousSibling.focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          maxLength={1}
          style={{
            width: "40px",
            height: "40px",
            textAlign: "center",
            fontSize: "20px",
            border: "none",
            borderBottom: "4px solid black",
            outline: "none",
          }}
        />
      ))}
    </div>
  );
};

export default OtpInput;
